import { useSelector } from 'react-redux';
import { thoughtspot } from 'config';
import { initialiseThoughtspot } from 'utils/thoughtspotInit';
import { cancelFunctions } from 'utils/cancelFunctions';
import { Store } from 'components/common/types/Store.types';
import LiveboardVisuals from 'components/common/LiveboardVisuals';
import {
  labsReportVisibleActions,
  TABS_STYLES,
  filterByAssetOwner,
  hiddenAssetOwnerThoughtspotLiveboardStyles,
} from '../LabsReportDropdown/utils';
import { getUpdateParametersForTimeRange, getUpdateParametersForTimezone } from '../utils';

const DealHealthUS: React.FC = () => {
  const { localeCode, marketId, timezone, timezoneOverride } = useSelector(
    (state: Store) => state.publisher.configuration,
  );

  initialiseThoughtspot(localeCode, cancelFunctions);

  const today = new Date();
  const liveboardUpdateParameters = [
    ...getUpdateParametersForTimezone(timezoneOverride ?? timezone),
    ...getUpdateParametersForTimeRange({ startDate: today, endDate: today }),
  ];

  return (
    <div className={TABS_STYLES}>
      <LiveboardVisuals
        liveboardId={thoughtspot.dealHealthUSDashboardId}
        customizations={hiddenAssetOwnerThoughtspotLiveboardStyles}
        visibleActions={labsReportVisibleActions}
        filterByOptions={[filterByAssetOwner(marketId)]}
        updateLiveboardParameters={liveboardUpdateParameters}
      />
    </div>
  );
};

export default DealHealthUS;
